import React, { useState } from "react";
import Contacts from "@/pages/contacts";

const Newzealandstudentvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/newzelands.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
      <div className="text-center lg:text-left  md:ml-32 mt-10  lg:w-3/4 text-2xl lg:text-3xl font-bold text-[#011473] drop-shadow-md">
  New Zealand Student Visa: Gateway to World-Class Education
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/student.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-2 lg:w-1/2">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Future-Ready Education:</a> Gain skills, knowledge and global networks for a limitless future.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">  World-Class Excellence:</a> Renowned for high-quality education and groundbreaking achievements.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Top-Tier Standards:</a> Education quality is guaranteed and globally recognized.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Diverse Culture:</a> A safe, friendly and welcoming multicultural society.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Exceptional Living:</a> High standard of living with opportunities for part-time work.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Global Recognition:</a> Qualifications respected by employers and institutions worldwide.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Student Support:</a> Institutions provide comprehensive support for international students.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
     <a className="text-black font-bold"> Unified System:</a> Governed by the New Zealand Qualifications Framework for consistent quality.
    </span>
  </div>
</div>




      </div>
      
      <div className="mx-8 mb-20 md:mx-32">
  <p className="mb-5 text-center md:text-left text-2xl md:text-3xl font-bold text-[#011473]">
    Work Opportunities During & After Studies in New Zealand
  </p>

  <div className="space-y-4">
    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Term-Time Work Limit:</a> Students and dependents can work up to 20 hours per week during academic terms.
      </span>
    </div>

    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Full-Time Work:</a> Unlimited work hours are allowed during official course breaks.
      </span>
    </div>

    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Proposed Change:</a> Work may be measured as 40 hours per fortnight during term sessions under the new arrangement.
      </span>
    </div>

    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Fortnight Definition:</a> A fortnight refers to a 14-day period starting on a Monday.
      </span>
    </div>

    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
       <a className="text-black font-bold"> Special Provisions:</a>Dependents of Master's by research and Doctoral students can work full-time without restrictions.
      </span>
    </div>

    <div className="flex items-center justify-center md:justify-start">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
        These flexible work arrangements enhance opportunities for international students and their families.
      </span>
    </div>
  </div>
</div>




  
     

     
      <Contacts />
    </>
  );
};

export default Newzealandstudentvisa;
